<div class="d-flex flex-column justify-content-start align-items-center h-100 w-100">

    <app-header-section
        class="w-100"
        [title]="headerTitle"
        [buttonText]="headerButtonText"
        [buttonIcon]="headerButtonIcon"
        [buttonUrl]="headerButtonUrl">
    </app-header-section>

    <div class="card d-flex flex-column justify-content-start align-items-stretch h-100 w-75 my-3">

        <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

        <div *ngIf="!isLoadingData" class="container-fluid p-4">

            <p-message
                styleClass="w-100"
                *ngIf="loadingMessage.show"
                [severity]="loadingMessage.severity"
                [text]="loadingMessage.text">
            </p-message>

            <div *ngIf="genders && extraInfos">

                <div *ngIf="student" class="h-100">
                    <app-student-edit
                        [student]="student"
                        [genders]="genders"
                        [extraInfos]="extraInfos">
                    </app-student-edit>
                </div>

                <div *ngIf="!student" class="h-100">
                    <app-student-edit
                        [genders]="genders"
                        [extraInfos]="extraInfos">
                    </app-student-edit>
                </div>

            </div>

        </div>

    </div>

</div>
